import { Button } from '@mantine/core';
import { Link } from 'react-router-dom';

interface Props {
  to: string;
  label: string;
  selected: boolean;
  onSelect: (option: string) => void;
}

export const SidebarButton = (props: Props): JSX.Element => {
  const { to, label, selected, onSelect } = props;
  return (
    <Link to={to}>
      <Button
        className={`text-slate-50 text-heading2 flex justify-start rounded-card
          ${selected ? 'bg-sidebar-active' : 'bg-transparent'} 
          hover:bg-sidebar-active`}
        fullWidth
        variant="subtle"
        onClick={() => {
          onSelect(to);
        }}
      >
        {label}
      </Button>
    </Link>
  );
};
